module.exports = __webpack_public_path__ + "static/sport/turntable.0ba10e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newldp/turntable.png
// module id = 9bPZ
// module chunks = 0